import { dispatchCustomEvent } from './events';
import { CallbackFn } from './utils.type';

/**
 * Global event bus for subscribing to and dispatching custom events on `document.body`.
 * @memberof SharedComponents
 * @alias eventBus
 */
export class EventBus {
    /**
     * @param {string} name
     * @param {Function} callback
     */
    addEventListener(
        name: string,
        callback: EventListenerOrEventListenerObject | CallbackFn
    ): void {
        HTMLElement.prototype.addEventListener.apply(document.body, [
            name,
            callback,
        ]);
    }

    /**
     * @param {string} name
     * @param {Function} callback
     */
    removeEventListener(
        name: string,
        callback: EventListenerOrEventListenerObject
    ) {
        HTMLElement.prototype.removeEventListener.apply(document.body, [
            name,
            callback,
        ]);
    }

    /**
     * @param {string} name
     * @param {*} [detail] - the event data object or value
     * @param {boolean} [bubbles] - enable event bubbling. Enabled by default
     * @param {boolean} [cancelable] - enable preventing default action. Enabled by default
     */
    dispatchCustomEvent(
        name: string,
        detail?: unknown,
        bubbles: boolean = true,
        cancelable: boolean = true
    ) {
        dispatchCustomEvent(document.body, name, detail, bubbles, cancelable);
    }
}

export const eventBus = new EventBus();
